import { Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bank } from "../../../Models/Banks";
import { getBanks } from "../../../Services/BankService";
import { postReferenceCodes } from "../../../Services/ReferceCodesService";
import { sendEvent } from "../../../Utils/analytics";
import { getRemoteValue } from "../../../Utils/firebase";
import useAuthState from "../../../Utils/store";
import BankInfosForEft from "./BankInfosForEft";
import EFTSkeleton from "./EFTSkeleton";

const EftTab = () => {
  const [banksForEft, setBankForEft] = useState<Bank[] | undefined>(undefined);
  const { paymentMethod, previewSummary } = useAuthState();
  const navigate = useNavigate();
  const [refCode, setRefCode] = useState<string>();

  const handleReferenceCode = async () => {
    if (paymentMethod) {
      const data = await postReferenceCodes(paymentMethod);
      if (data) {
        setRefCode(data.code);
        sendEvent(`view_checkout_eft_tab`, {
          reference_code: data?.code,
          colendi_iban: banksForEft && banksForEft[0]?.iban,
          total_payment_amount: previewSummary?.amount,
        });
      } else {
        navigate("/checkout#card");
      }
    }
  };
  useEffect(() => {
    handleBankForEft();
    handleReferenceCode();
  }, []);

  const handleBankForEft = async () => {
    const banksForEftData = await getBanks();
    setBankForEft(banksForEftData);
  };

  return (
    <>
      <Stack
        sx={{
          borderRadius: "16px",
          border: "1px solid #F1F5F9",
          boxShadow: "0px 4px 17px 0px #F1F1F4",
        }}
        className="p-4 md:p-6 mt-6"
      >
        <div className="text-[15px] md:text-[16px] font-semibold text-[#475569]">
          {getRemoteValue("eft_pay")}
        </div>

        <Stack>
          {banksForEft != undefined && refCode != undefined ? (
            banksForEft?.map((bank: Bank, index: number) => (
              <BankInfosForEft refCode={refCode} bank={bank} />
            ))
          ) : (
            <EFTSkeleton />
          )}
          <Stack
            sx={{ borderRadius: "12px", background: " #FAFAFB" }}
            className="mt-4 md:mt-6"
          >
            <p
              className="xs:text-sm md:text-base font-normal p-4"
              dangerouslySetInnerHTML={{
                __html: getRemoteValue("reference_code_desc"),
              }}
            ></p>
          </Stack>
          <Stack
            className="mt-4"
            flexDirection={"row"}
            alignItems={"center"}
            gap={"10px"}
          >
            <img
              src={"/icons/info-icon.svg"}
              style={{ color: "#74788D", width: "15px", height: "15px" }}
              alt=""
            />
            <p
              className="text-[12px] font-normal text-[#475569]"
              dangerouslySetInnerHTML={{
                __html: getRemoteValue("eft_refund_desc"),
              }}
            ></p>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};

export default EftTab;
